// 我们提供了监控 SDK 配套的 npm 包
import watchdog from '@hll/watch-dog-jsutil';
import { log } from '@/utils/log';

const defaultConfig = {
  sendPV: true,
  sendApi: true,
  sendResource: true,
  sendError: true,
  sendPerf: true,
  debug: false,
  silence: false,
};

// 设置用户标识
export function setWatchdogBizUserId(bizUserId: string) {
  try {
    watchdog.setConfig({
      ...defaultConfig,
      bizUserId,
    });
  } catch {
    log.log('监控设置标识错误');
  }
}
